/** Read an exact Cookie-header or document.cookie name. Invalid URI bytes are absent. */
export function readCookieHeader(cookieHeader: string, name: string): string | null {
  for (const part of cookieHeader.split(';')) {
    const pair = part.trim();
    const separator = pair.indexOf('=');
    if (separator < 0 || pair.slice(0, separator) !== name) continue;
    const value = pair.slice(separator + 1);
    if (!value) return null;
    try { return decodeURIComponent(value); }
    catch (error) {
      if (error instanceof URIError) return null;
      throw error;
    }
  }
  return null;
}

/** Mirror a UI preference for server first paint. This never serializes credentials. */
export function writePreferenceCookie(name: string, value: string): void {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=31536000; samesite=lax`;
}
